function StatCard({ label, value, description }) {
  return (
    <div className="rounded border border-slate-200 bg-white p-7">
      <p className="mb-6 text-xs font-bold uppercase text-[#8a96b2]">{label}</p>
      <div className="mb-8 text-5xl font-black leading-none lg:text-6xl">{value}</div>
      <p className="max-w-md text-base leading-7 text-slate-600">{description}</p>
    </div>
  );
}

export default StatCard;
